module.exports = __webpack_public_path__ + "img/link-external-02.13625085.svg";